import React, { memo } from 'react';
import styled from 'styled-components';
import DashboardChatbot from './DashboardChatbot';

const DashboardContainer = styled.div`
  flex: 1;
  min-height: 0;     
  display: flex;
  flex-direction: column;
  margin: 0;
  padding: 0;
  background: #f5f5f5;
  overflow: hidden;  
`;


const Grid = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  height: 100%;
  margin: 0;
  padding: 0;
`;

const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`;


const ProjectDashboard = memo(({ selectedProject, currentPage, sandboxMode }) => {
  return (
    <DashboardContainer>
      <Grid>
        <MainContent>
          <DashboardChatbot
            theme={selectedProject?.theme}
            projectId={selectedProject?.id}
            selectedRequirement={selectedProject?.selectedRequirement}
            allRequirements={selectedProject?.requirements || []}
            currentPage={currentPage}
            sandboxMode={sandboxMode}
          />
        </MainContent>
      </Grid>
    </DashboardContainer>
  );
}, (prevProps, nextProps) => {
  return prevProps.selectedProject?.id === nextProps.selectedProject?.id});

ProjectDashboard.displayName = 'ProjectDashboard';

export default ProjectDashboard; 